export default __webpack_public_path__ + "static/thumb-landscape-41426ac14686323481cf64c1bd40dbc2.jpg";